import { Button } from "@material-tailwind/react";
import '../styles/lines.css';

export default function SmallButton({ icon, text, href }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <Button
        className="flex w-auto items-center gap-2 bg-[#f5f7f9] px-4 py-2 text-white rounded-lg shadow-md hover:from-pink-500 hover:to-purple-500 "
      >
        {icon}
        <p className="text-[#1f2739] font-poppins">{text}</p>
      </Button>
    </a>
  );
}
